// Footer.jsx
import { useTranslation } from "react-i18next";

const Footer = () => {
   const { t } = useTranslation();  
  return (
    <footer className="bg-white mt-5 border-top">
      <div className="container py-4 text-center" dir="rtl">
        <div className="row g-4 text-center">

          {/* צד ימין – פרטי קשר */}
          <div className="col-md-6 text-center text-md-start">

            <h5 className="text-danger mb-3 text-center">{t("contact_title")} </h5>

            {/* כפתור הוספה לאנשי קשר */}
            <a
              href="/israel-kitchen.vcf"
              download
              className="btn btn-outline-danger btn-sm mb-2 d-block text-center"
            >
{t("add_to_contacts")}            </a>

            {/* וואטסאפ / טלפון */}
            <a
              href="https://wa.me/13476154450"
              target="_blank"
              rel="noopener noreferrer"
              className="d-block mb-2 text-success text-decoration-none text-center"
            >
              <i className="bi bi-whatsapp me-2"></i>
              347-6154450 -  {t("order_phone")}
            </a>

            {/* פייסבוק */}
            <a
              href="https://www.facebook.com/profile.php?id=61584003513237"
              target="_blank"
              rel="noopener noreferrer"
              className="d-block text-primary text-decoration-none text-center"
            >
              <i className="bi bi-facebook me-2"></i>
                {t("find_us_facebook")}            
            </a>
          </div>

          {/* צד שמאל – משלוחים ואיסוף */}
          <div className="col-md-6">
            <div className="bg-light p-3 rounded shadow-sm text-center">
              <h5 className="mb-2">📦  {t("delivery_pickup_title")}</h5>

              <p className="mb-1">
                🚚 <strong> {t("delivery_extra")}</strong>
                
              </p>
              <h5>{t("delivery_cost")}</h5>
              {/* כפתור מיקום */}
              <div className="text-center w-100 my-2">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=2600+Netherland+Ave+Bronx+NY"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-light p-1 mx-auto d-flex justify-content-center align-items-center"
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  <i
                    className="bi bi-geo-alt-fill"
                    style={{ fontSize: "20px", color: "red" }}
                  ></i>
                </a>

                <p className="mt-1 mb-0">{t("self_pickup")}  </p>
              </div>

              <hr />

              <p className="text-muted mb-0">
              {t("orders_until")}
              </p>
            </div>
          </div>

          {/* שורת קרדיט קטנה למטה */}
          <div className="col-12 text-center mt-3">
            <small className="text-muted">
              © {new Date().getFullYear()}   {t("footer_rights")}
            </small>
            <img
                src="/logo192.png"   // תשני לנתיב הלוגו שלך
                alt="Israel Kitchen logo"
                className="logo-small me-2"
                style={{ width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        borderRadius: "50%"}}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
